module.exports = __webpack_public_path__ + "9bf411d85150f80f62d5a1571eac85fb.svg";